const html = require('choo/html');
const Map = require('../components/map');
// const TopList = require('../components/top_list');
const InfoPanel = require('../components/info-panel');

// const DeckMap = require('../components/deck_map');

const TITLE = 'plotter - main';

module.exports = view;

function getLocation(locations, highlightLocation) {
  return locations.filter((l) => {
    return l[highlightLocation.key] == highlightLocation.id;
  })[0];
}

function view(state, emit) {
  if (state.title !== TITLE) emit(state.events.DOMTITLECHANGE, TITLE);

  // state.cache(DeckMap, 'plot-map').render(state.locations)

  /*
            <input
          class="mt2"
          type="file"
          id="locationsInput"
          onchange=${(evt) => {
          // console.log(evt.target.files[0]);
          emit('map:load-file', evt.target.files[0]);
        }}
        />
*/
  // console.log(state.highlightLocation);
  return html`
    <body class="code lh-copy pa3 bg-white">
      <div class="w-100 content-container">
        ${state
          .cache(Map, 'plot-map')
          .render(state.locations, state.highlightLocation, facilityClick, {
            minZoom: 4
          })}
        ${state.highlightLocation
          ? InfoPanel(state.selectedFacility, closeClick)
          : ''}
      </div>
      <div
        class="flex justify-around-ns justify-between items-start flex-wrap lh-solid-ns"
      >
        <div class="flex items-center">
          <span class="red f2 dib mr1">•</span>
          <span class="TIMono"
            >Revised ethylene oxide emissions after 2018</span
          >
        </div>
        <div class="flex items-center mh2-ns">
          <span class="green f2 dib mr1">•</span>
          <span class="TIMono">Did not revise emissions after 2018</span>
        </div>
        <div class="flex items-center">
          <span class="yellow f2 dib mr1">•</span>
          <span class="TIMono"
            >Reported large reductions in emissions after 2018</span
          >
        </div>
      </div>
    </body>
  `;

  function showAllToggle(evt) {
    evt.preventDefault();
    evt.stopPropagation();

    emit('map:show-all-toggle');
  }

  function closeClick(evt) {
    evt.preventDefault();
    evt.stopPropagation();

    emit('map:closeInfoBox');
  }

  function facilityClick(facilityId, evt) {
    evt.preventDefault();
    evt.stopPropagation();

    emit('map:zoom-to-id', {
      key: 'tri_facility_id',
      id: facilityId
    });
  }
}
